export default {
    // **只读信息 任务相关
    task:[
        1002,  //  本BU有任务待接收（接收方）
        1003,  //  本BU有人发布了任务（发布方）
        1004,  //  本BU有人接收了任务（接收方）
        1005,  //  对方BU接收了任务（发布方）
        1007,  //  本BU拒收了任务（接收方）
        1008,  //  对方BU拒收了任务（发布方）
        1009,  //  本BU有人取消了任务（接收方）
        1010,  //  对方BU申请取消任务（发布方）
        1011,  //  对方BU同意取消任务（接收方）
        1012,  //  本BU同意取消任务（发布方）
        1014,  //  对方BU不同意取消任务（接收方）
        1015,  //  本BU不同意取消任务（发布方）
        1016,  //  对方BU发起了投诉（接收方）
        1017,  //  本BU发起了投诉（发布方）
        1019,  //  本BU提交任务验收（接收方）
        1020,  //  本BU有任务待验收（发布方）
        1021,  //  本BU任务验收成功，任务完成（接收方）
        1022,  //  对方BU通过任务验收，任务完成（发布方）
        1023,  //  本BU任务验收失败（接收方）
        1024,  //  对方BU未通过任务验收（发布方）
        1025,  //  任务过审后，本BU有任务待接收（接收方）
        1026,  //  本BU有任务过审发布（发布方）
        1028,  //  本BU有任务审核失败（发布方）
        1030,  //  本BU任务取消过审（接收方）
        1031,  //  对方BU任务取消过审（发布方）
        1033,  //  本BU任务取消未能过审（接收方）
        1034,  //  对方BU任务取消未能过审（发布方）
        1036,  //  对方BU任务投诉过审（接收方）
        1037,  //  本BU任务投诉过审（发布方）
        1039,  //  对方BU任务投诉未能过审（接收方）
        1040,  //  本BU任务投诉未能过审（发布方）
        1042,  //  对方BU终止拒收的任务（接收方）
        1043,  //  本BU终止被拒收的任务（发布方）
    ],   
    // **只读信息 审核相关
    examine:[
        1001,  //  任务发布 需要审核
        1013,  //  任务取消 需要审核
        1018,  //  任务投诉 需要审核
        1027,  //  任务发布审核通过
        1029,  //  任务发布审核不通过
        1032,  //  任务取消审核通过
        1035,  //  任务取消审核不通过
        1038,  //  任务投诉审核通过
        1041,  //  任务投诉审核不通过
    ],
    // **公告
    notice:[
    ],     
    // **弹窗信息
    alert:[
        1006,  //  被指派为任务执行者
    ],
}



// WEBPACK FOOTER //
// ./src/config/info-types.js